import { useEffect, useState } from 'react';
import { api } from '../api.js';
import type { OptionCardView } from '../api.js';
import { modeCards } from '../gameSetup.js';
import { Panel } from './Panel.js';

/** Every bot, as the bot exe lists them. */
export function BotList({ onClose }: { onClose: () => void }) {
  return (
    <Panel title="Bots" onClose={onClose} wide>
      <table className="reference-table">
        <tbody>
          {__BOTS__.map((b) => (
            <tr key={b.name}>
              <td>{b.name}</td>
              <td>{b.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
}

/**
 * Every Option card of the game's mode, with its text. Outside a game,
 * the normal mode's.
 */
export function OptionList({ onClose, turnMode, debris }: {
  onClose: () => void;
  turnMode: boolean;
  debris: boolean;
}) {
  const [cards, setCards] = useState<OptionCardView[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api.optionCatalog().then(
      ({ options }) => setCards(modeCards(options, turnMode, debris)
        .sort((a, b) => a.name.localeCompare(b.name))),
      () => setFailed(true),
    );
  }, [turnMode, debris]);

  return (
    <Panel title="Option cards" onClose={onClose} wide>
      {failed && <p className="notice">Could not load the Option cards.</p>}
      {!cards && !failed && <p className="muted">Loading</p>}
      {cards && (
        <dl className="reference-list">
          {cards.map((o) => (
            <div key={o.id} className="reference-option">
              {/* The card's art, by effect; blank where there is none. */}
              <img
                className="option-icon"
                src={`/options/${o.effect}.png`}
                alt=""
                onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
              />
              <div>
                <dt>{o.name}</dt>
                {o.text.split('\n\n').map((para) => <dd key={para}>{para}</dd>)}
              </div>
            </div>
          ))}
        </dl>
      )}
    </Panel>
  );
}
